import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const {
  BreakpointNames: { sm },
} = constants.breakpoints;

const white = constants.colors.brand.white[100];
const grey100 = constants.colors.ui.neutral[100];
const grey700 = constants.colors.ui.neutral[700];

export const closeButtonCss = {
  alignSelf: "start" as const,
  marginTop: "2px",
  [mq.downTo(sm)]: {
    marginTop: "0px",
  },
  color: grey700,
  "& svg": {
    height: "27px",
  },
  marginRight: "-10px,",
};

export const headerTitleCss = {
  fontWeight: "700",
  fontFamily: "Noto Serif",
  fontSize: "20px",
  margin: "0px",
  lineHeight: "31.92px",
  color: grey700,
};

export const modalCss = {
  width: "100%",
  boxShadow: "0px 16px 40px rgba(0, 0, 0, 0.32)",
  zIndex: 99,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const modalHeaderCss = {
  display: "flex" as const,
  flexDirection: "row" as const,
  justifyContent: "space-between" as const,
  width: "100%",
  height: "64px",
  borderBottom: "1px solid" + grey100,
  padding: "16px",

  [mq.downTo(sm)]: {
    padding: "16px 32px",
  },
};

export const wrapperCss = {
  borderRadius: "16px",
  background: white,
  boxShadow: "0px 2px 6px 0px rgba(29, 29, 29, 0.16)",
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "center" as const,
  justifyContent: "start" as const,
  position: "relative" as const,
  padding: 0,
  gap: 10,
  margin: "0px 18px",
  width: "800px",
  height: "auto",
  boxSizing: "border-box" as const,
};
